var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("div", { staticClass: "container azSize has-text-dark" }, [
      _c("div", { staticClass: "is-size-3" }, [_c("b", [_vm._v("Try")])]),
      _vm._v(" "),
      _c("div", [
        _vm._v("You can try the slink "),
        _c("span", {}, [_c("b", [_vm._v(_vm._s(_vm.tgtSlink))])]),
        _vm._v(" for 14 days. The slink will expire after this period")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "top20" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  !_vm.$root.isAuth &&
                  !_vm.trialed &&
                  !_vm.sentEmail &&
                  !_vm.exists,
                expression: "!$root.isAuth && !trialed && !sentEmail && !exists"
              }
            ]
          },
          [
            _c("div", [
              _vm._v(
                "Enter your email address to continue, we will send you a link to set up your slink"
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass: "input has-background-dBlue",
              attrs: { type: "text" },
              domProps: { value: _vm.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.email = $event.target.value
                }
              }
            }),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "button is-warning", on: { click: _vm.go } },
              [_vm._v("GO")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.exists,
                expression: "exists"
              }
            ]
          },
          [
            _vm._v(
              "\n               We found an account under this email address, please log in to continue."
            ),
            _c("br"),
            _vm._v(" "),
            _c("button", { staticClass: "button is-warning" }, [
              _vm._v("Log In")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.trialed,
                expression: "trialed"
              }
            ]
          },
          [
            _vm._v(
              "\n               This email address has already tried the Slink "
            ),
            _c("b", [_vm._v(_vm._s(_vm.tgtSlink))]),
            _vm._v(
              ". If you want to continue using it, please register and purchase a subscription for it."
            ),
            _c("br"),
            _vm._v(" "),
            _c("button", { staticClass: "button is-warning" }, [
              _vm._v("Register")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sentEmail,
                expression: "sentEmail"
              }
            ]
          },
          [
            _vm._v(
              "\n               Please check your email! We have sent you instructions on how to set up your slink trial.\n           "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$root.isAuth,
              expression: "$root.isAuth"
            }
          ],
          staticClass: "top10"
        },
        [_c("b", [_vm._v("Logged in flow")])]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b722bd72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b722bd72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Try.vue
// module id = null
// module chunks = 